import { useNavigation } from "@react-navigation/native";
import { useCallback } from "react";

import { useConfig, useUser } from "../services";
import { Banner, CalloutRefresh, SocialsForm } from "../components";
import { LoadingScreen } from "./loading";

export function SocialsScreen() {
  // Data
  const {
    data: config,
    isLoading: isConfigLoading,
    refetch: refetchConfig,
  } = useConfig();
  const {
    data: user,
    isLoading: isUserLoading,
    refetch: refetchUser,
  } = useUser();

  // Vars
  const navigation = useNavigation();

  // Methods
  const refresh = useCallback(() => {
    refetchUser();
    refetchConfig();
  }, [refetchUser, refetchConfig]);

  // Handlers
  const handleSuccess = useCallback(() => {
    navigation.goBack();
  }, [navigation]);

  // Render
  if (isUserLoading || isConfigLoading) {
    return <LoadingScreen />;
  }

  if (!user || !config) {
    return <CalloutRefresh onRefresh={refresh} />;
  }

  return (
    <>
      <Banner message="These contact details are visible to clients." mb="2" />
      <SocialsForm onSuccess={handleSuccess} config={config} user={user} />
    </>
  );
}
